import React, { useState } from 'react';
import { SecureDocumentViewer } from './components/SecureDocumentViewer';
import { Document, Folder } from './types/documents';
// Initial Mock Data
const INITIAL_FOLDERS: Folder[] = [{
  id: 'FLD-001',
  name: 'Income & Employment',
  documentIds: ['DOC-004', 'DOC-005']
}, {
  id: 'FLD-002',
  name: 'Legal & Compliance',
  documentIds: ['DOC-006']
}, {
  id: 'FLD-003',
  name: 'Property',
  documentIds: ['DOC-002']
}];
const INITIAL_DOCUMENTS: Document[] = [{
  id: 'DOC-001',
  name: 'Loan Application Form',
  type: 'Application',
  date: 'Jan 15, 2025',
  fileType: 'PDF',
  size: '2.4 MB'
}, {
  id: 'DOC-002',
  name: 'Property Appraisal Report',
  type: 'Appraisal',
  date: 'Jan 22, 2025',
  fileType: 'PDF',
  size: '5.1 MB',
  folderId: 'FLD-003'
}, {
  id: 'DOC-003',
  name: 'Federal Tax Returns 2023',
  type: 'Tax Document',
  date: 'Jan 10, 2025',
  fileType: 'PDF',
  size: '1.8 MB'
}, {
  id: 'DOC-004',
  name: 'Pay Stubs - Last 3 Months',
  type: 'Income Proof',
  date: 'Jan 12, 2025',
  fileType: 'PDF',
  size: '890 KB',
  folderId: 'FLD-001'
}, {
  id: 'DOC-005',
  name: 'Bank Statements - Q4 2024',
  type: 'Asset Proof',
  date: 'Jan 18, 2025',
  fileType: 'PDF',
  size: '3.2 MB',
  folderId: 'FLD-001'
}, {
  id: 'DOC-006',
  name: 'Title Insurance Policy',
  type: 'Legal',
  date: 'Jan 20, 2025',
  fileType: 'PDF',
  size: '1.1 MB',
  folderId: 'FLD-002'
}];
export function App() {
  const [documents, setDocuments] = useState<Document[]>(INITIAL_DOCUMENTS);
  const [folders, setFolders] = useState<Folder[]>(INITIAL_FOLDERS);
  const handleCreateFolder = (name: string) => {
    const newFolder: Folder = {
      id: `FLD-${Date.now()}`,
      name,
      documentIds: []
    };
    setFolders([...folders, newFolder]);
  };
  const handleMoveDocument = (docId: string, folderId: string | undefined) => {
    setDocuments(prevDocs => prevDocs.map(doc => doc.id === docId ? {
      ...doc,
      folderId
    } : doc));
    // Also update the folder documentIds arrays to keep them in sync
    setFolders(prevFolders => prevFolders.map(folder => {
      // If this is the new folder, add the docId
      if (folder.id === folderId) {
        return {
          ...folder,
          documentIds: [...new Set([...folder.documentIds, docId])]
        };
      }
      // If this is any other folder, remove the docId
      return {
        ...folder,
        documentIds: folder.documentIds.filter(id => id !== docId)
      };
    }));
  };
  return <div className="min-h-screen bg-[#F3F3F3] font-sans text-[#181818] flex flex-col" data-id="element-0">
      {/* Main Content Area */}
      <main className="flex-1 max-w-7xl w-full mx-auto p-4 sm:p-6 flex flex-col gap-6" data-id="element-1">
        <SecureDocumentViewer documents={documents} folders={folders} viewerState="default" onCreateFolder={handleCreateFolder} onMoveDocument={handleMoveDocument} data-id="element-2" />
      </main>
    </div>;
}